import clsx from 'clsx';
import React, { FC } from 'react';

export enum TagColor {
  slate = 'slate',
  umber = 'umber',
  mink = 'mink',
  'dark-brown' = 'dark-brown',
  twig = 'twig',
  mauve = 'mauve',
  taupe = 'taupe',
  ash = 'ash',
  'light-grey' = 'light-grey',
}

export interface MktTagProps {
  /**
   * The content to render inside the component.
   * @defaultValue undefined
   */
  children: string;

  /**
   * Tag background color
   * @defaultValue mauve
   */
  color?: `${TagColor}`;
}

export const MktTag: FC<MktTagProps> = ({ children, color = 'mauve' }) => {
  const colorHandler = (color: `${TagColor}`) => {
    switch (color) {
      case TagColor['dark-brown']:
        return 'wh-bg-dark-brown';
      case TagColor.mink:
        return 'wh-bg-mink';
      case TagColor.slate:
        return 'wh-bg-slate';
      case TagColor.umber:
        return 'wh-bg-umber';
      case TagColor.twig:
        return 'wh-bg-twig';
      case TagColor.taupe:
        return 'wh-bg-taupe';
      case TagColor.mauve:
        return 'wh-bg-mauve';
      case TagColor['light-grey']:
        return 'wh-bg-light-grey';
      case TagColor.ash:
        return 'wh-bg-ash';
      default:
        return 'wh-bg-mauve';
    }
  };

  return (
    <span
      className={clsx(
        'wh-font-sans',
        'wh-text-xs',
        'wh-py-[5px]',
        'wh-px-[12px]',
        'wh-rounded-2xl',
        'wh-border-[1px]',
        'wh-inline-block',

        'wh-text-white',
        'wh-min-w-[123px]',
        colorHandler(color),
      )}
    >
      {children}
    </span>
  );
};
